import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { RouteGuard } from "./router/guards";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <RouteGuard>
        <AppRoutes />
      </RouteGuard>
    </BrowserRouter>
  );
}

export default App;
